import { SERP_TABS_FLAG, SerpTabsVariant } from '@/constants/experimentConstants';
import type { Variants } from '@amplitude/experiment-js-client';

export function toSerpTabsVariant(payload: unknown): SerpTabsVariant {
  return (payload as { variant?: unknown } | undefined)?.variant === 'tabbed' ? 'tabbed' : 'control';
}

export function getSerpTabsVariant(flags: Variants | undefined): SerpTabsVariant {
  return toSerpTabsVariant(flags?.[SERP_TABS_FLAG.name]?.payload);
}
